module.exports = __webpack_public_path__ + "static/Delivery Hero-6a9e8d9a37bd09700b1f999256d386c2.jpg";